import React from 'react';
import { useSystemSession } from 'hooks/useSystemSession';

interface SystemSessionGuardProps {
  show?: boolean;
  children: React.ReactElement;
}

export const SystemSessionGuard = React.memo(({ show, children }: SystemSessionGuardProps) => {
  const isSystemSession = useSystemSession();

  // eslint-disable-next-line no-nested-ternary
  return isSystemSession ? (show ? children : null) : children;
});
